const riot = require('riot');

riot.tag2('atom-tabs', '<div class="f fbw w-full bg-white box-shadow"> <button class="f fh w-full" each="{item,index in opts.tabs}" onclick="{onChangeTab}"> <div class="relative pt10 pb12 bold {item.id === current ? &quot;text-primary&quot; : &quot;&quot;}">{item.label}</div> </button> </div> <div class="h0"> <div class="h3 w-full relative tn3 transition-128 bg-primary rounded-2" ref="bar"></div> </div>', '', '', function(opts) {
    this.on('mount', () => {
      if (spat.isBrowser) {
        this.current = this.opts.current || this.opts.tabs[0].id;
        this.setBarAnim();
        this.update();
      }
    });

    this.setCurrent = (id) => {
      this.current = id;
      this.currentIndex = (this.opts.tabs.findIndex(l => (l.id === id)));
      this.setBar();
      this.update();
    };

    this.onChangeTab = (e) => {

      if (this.current === e.item.item.id) return;
      this.current = e.item.item.id;
      this.currentIndex = e.item.index;
      this.setBarAnim();
      this.trigger('change', this.current);
    };

    this.setBar = () => {

      var per = 100 / (this.opts.tabs.length);
      var left = this.currentIndex * per;
      this.refs.bar.style = `width: ${per}%; left: ${left}%;`;
      this.preLeft = left;
    };

    this.setBarAnim = () => {

      var per = 100 / (opts.tabs.length);
      var left = this.currentIndex * per;
      this.preLeft = this.preLeft || 0;

      if (this.preLeft - left >= 0) {
        this.refs.bar.style = `width: ${per*1.8}%; left: ${left}%`;
      }
      else {
        this.refs.bar.style = `width: ${per + (left - this.preLeft)*0.8}%; left: ${this.preLeft}%`;
      }
      setTimeout(() => {
        this.setBar();
      }, 128);
      this.preLeft = left;
    };
});